<template>
  <div class="home-index">
    <!-- 轮播图 -->
    <div class="carousel">
      <template v-if="!is_Empty(banner)">
        <el-carousel>
          <el-carousel-item v-for="(item,k) in banner" :key="k">
            <img :src="item.banner_img" alt/>
          </el-carousel-item>
        </el-carousel>
      </template>
      <div class="login fr ac jfe" v-if="checkMember && false">
        <div class="content">
          <div v-if="!$store.state.is_login" class="top fc ac">
            <img src="/static/imgs/home/avatar.png" class="avatar mt20 mb20" alt/>
            <el-button type="primary" size="mini" @click="go('/login')">登录</el-button>
          </div>
          <div class="bottom fc ac pb30 pt10" :class="{pt50:$store.state.is_login}">
            <img src="/static/imgs/home/ad.png" class="ad" alt/>
            <div class="vip fr ac jc mb20 cursor fs" @click="toApplyCompany">
              <i class="el-icon-office-building fz18 white mr10"></i>
              <span class="fz14 white">成为VIP客户</span>
            </div>
            <div class="supplier fr ac jc cursor fs" @click="toApplyMerchants">
              <i class="el-icon-office-building fz18 mr10"></i>
              <span class="fz14">成为供应商</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- main -->
    <div class="main">
      <div class="show-content fr ac jsb">
        <div class="content-item fr ac jsa cursor" @click="go(`mall?goods_type=1`)">
          <img src="/static/imgs/home/img_1.png" class="img" alt/>
          <div class="fc afe">
            <span class="fz30 white bold">定制商品</span>
            <p class="fz16 white mt20">您想要的规格，随意订做</p>
          </div>
        </div>
        <div class="content-item fr ac jsa cursor" @click="go(`mall?goods_type=2`)">
          <img src="/static/imgs/home/img_3.png" class="img" alt/>
          <div class="fc afe">
            <span class="fz30 white bold">标准商品</span>
            <p class="fz16 white mt20">行业内的标准，品类齐全</p>
          </div>
        </div>
        <div class="content-item fr ac jsa cursor" @click="go(`mall?goods_type=3`)">
          <img src="/static/imgs/home/img_2.png" class="img" alt/>
          <div class="fc afe">
            <span class="fz30 white bold">配件及维修设备</span>
            <p class="fz16 white mt20">为您的生产设备保驾护航</p>
          </div>
        </div>
      </div>
      <!-- 为你推荐商品 -->
      <div class="goods-box">
        <div class="brick-img-item brick-item">
          <img :src="ad[0].banner_img" v-if="!is_Empty(ad[0])" class="left" alt/>
        </div>
        <el-card shadow="hover" class="right">
          <div class="fr ac jsb" slot="header">
            <span>为你推荐</span>
            <div class="fr ac cursor" @click="go(`mall?type=1`)">
              <span class="grey fz14">更多</span>
              <i class="el-icon-arrow-right"/>
            </div>
          </div>
          <div class="fr fw pb20">
            <goods-cell
                v-for="(i,j) in goods_list"
                :key="i.goods_id"
                :goods="i"
                :class="{mr10:(j+1)%4 !=0}"
            />
          </div>
        </el-card>
      </div>
      <!-- 促销商品 -->
      <div class="goods-box">
        <div class="brick-img-item brick-item">
          <img :src="ad[1].banner_img" v-if="!is_Empty(ad[1])" class="left" alt/>
        </div>
        <el-card shadow="hover" class="right">
          <div class="fr ac jsb" slot="header">
            <span>促销商品</span>
            <div class="fr ac cursor" @click="go(`mall?type=2`)">
              <span class="grey fz14">更多</span>
              <i class="el-icon-arrow-right"/>
            </div>
          </div>
          <div class="fr fw pb20">
            <goods-cell
                v-for="(i,j) in promotion_list"
                :key="i.goods_id"
                :goods="i"
                :class="{mr10:(j+1)%4 !=0}"
            />
          </div>
        </el-card>
      </div>
      <!-- 配件及维修设备商品 -->
      <div class="goods-box">
        <div class="brick-img-item brick-item">
          <img :src="ad[2].banner_img" v-if="!is_Empty(ad[2])" class="left" alt/>
        </div>
        <el-card shadow="hover" class="right">
          <div class="fr ac jsb" slot="header">
            <span>配件及维修设备</span>
            <div class="fr ac cursor" @click="go(`mall?type=3`)">
              <span class="grey fz14">更多</span>
              <i class="el-icon-arrow-right"/>
            </div>
          </div>
          <div class="fr fw pb20">
            <goods-cell
                v-for="(i,j) in accessories_list"
                :key="i.goods_id"
                :goods="i"
                :class="{mr10:(j+1)%4 !=0}"
            />
          </div>
        </el-card>
      </div>
    </div>
    <!-- 向上滚动 -->
    <el-backtop target=".home-page" class="fc ac jsb" :bottom="100">
      <div class="back-top fr ac jc">
        <img src="/static/imgs/home/top.png" alt/>
      </div>
      <div class="back-top fr ac jc">
        <img src="/static/imgs/home/service.png" alt/>
      </div>
    </el-backtop>
  </div>
</template>

<script>
import GoodsCell from "@/components/GoodsCell";

export default {
  props: {},
  data() {
    return {
      goods_nav: ["为你推荐", "促销商品", "配件及维修设备"],
      goods_list: [],
      promotion_list: [],
      accessories_list: [],
      banner: [], //轮播图
      memberInfo: "",
      company_info: {},
      merchants_info: {},
      ad: [], //广告
    };
  },
  computed: {
    checkMember() {
      if (!this.$store.state.is_login) {
        return true;
      }
      if (this.is_Empty(this.memberInfo)) {
        return false;
      }
      return false;
    }
  },
  async created() {
    // 轮播图
    let res = await this.post("settingInterfaces/v1.0/getBanners", {
      banner_position: "pc-banner",
    });
    this.banner = res.data;
    res = await this.post("settingInterfaces/v1.0/getBanners", {
      banner_position: "pc-ad",
    });
    this.ad = res.data;
    // this.getBanner(1);
    // this.getBanner(3);
    // 推荐商品
    this.goodsList({is_recommend: 1, type: 1});
    // 促销商品
    this.goodsList({is_promote: 1, type: 2});
    // 配件及维修设备
    this.goodsList({goods_type: 3, type: 3});
    //获取用户信息
    if (!this.is_Empty(this.$store.state.memberInfo)) {
      this.getMemberInfo();
    }
  },
  methods: {
    //去申请vip客户
    toApplyCompany() {
      if (this.hasMemberType(3)) {
        this.$message("您已是供应商 不能申请vip客户");
        return;
      }

      //没有申请
      if (JSON.stringify(this.company_info) == "{}") {
        this.go("/register/applyCompany");
      }
      //  审核中

      if (this.company_info.apply_state == "0") {
        this.$alert("您的资料正在审核中,请注意查看系统消息", "", {
          center: true,
        });
      }

      //  审核通过
      if (this.company_info.apply_state == "1") {
        this.$message("您已是vip客户");
      }
      //审核拒绝
      if (this.company_info.apply_state == "2") {
        this.$confirm(
            "您的资料审核失败,失败原因  [" + this.company_info.refuse_desc + "]",
            "提示",
            {
              confirmButtonText: "重新提交",
              cancelButtonText: "取消",
              type: "warning",
              center: true,
            }
        )
            .then(() => {
              this.go("/register/reapplyCompany");
            })
            .catch(() => {
            });
      }
    },
    //去申请供应商
    toApplyMerchants() {
      if (this.hasMemberType(2)) {
        this.$message("您已是vip客户,不能申请供应商");
        return;
      }

      //没有申请
      if (JSON.stringify(this.merchants_info) == "{}") {
        this.go("/register/applyMerchants");
      }
      //  审核中

      if (this.merchants_info.apply_state == "0") {
        this.$alert("您的资料正在审核中,请注意查看系统消息", "", {
          center: true,
        });
      }

      //  审核通过
      if (this.merchants_info.apply_state == "1") {
        this.$message("您已是供应商");
      }
      //拒绝
      if (this.merchants_info.apply_state == "2") {
        this.$confirm("您的资料审核失败", "提示", {
          confirmButtonText: "重新提交",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
            .then(() => {
              this.go("/register/reapplyMerchants");
            })
            .catch(() => {
            });
      }
    },

    //获取用户信息
    getMemberInfo() {
      this.post("memberInterfaces/v1.0/getMemberDetail", {}).then((res) => {
        this.memberInfoInit(res.data);
        this.$forceUpdate();
      });
    },
    //获取公司详情
    getCompanyDetail() {
      let param = {};
      this.post("companyInterfaces/v1.0/getCompanyDetail", param).then(
          (res) => {
            this.company_info = res.data;
          }
      );
    },
    //获取供应商详情
    getMerchantsDetail() {
      let param = {};
      this.post("merchantsInterfaces/v1.0/getMerchantsDetail", param).then(
          (res) => {
            this.merchants_info = res.data;
          }
      );
    },

    goodsList(obj) {
      obj.page = 1;
      obj.pageSize = 8;
      this.post("goodsInterfaces/v1.0/getGoodsList", obj).then((res) => {
        if (res.status == "ok") {
          if (obj.type == 1) {
            // 推荐商品
            this.goods_list = res.data;
          } else if (obj.type == 2) {
            // 促销商品
            this.promotion_list = res.data;
          } else if (obj.type == 3) {
            // 配件及维修设备
            this.accessories_list = res.data;
          }
        }
      });
    },
    // 首页轮播图/获取广告图片
    getBanner(banner_position) {
      this.post("settingInterfaces/v1.0/getBanners", {
        banner_position,
      }).then((res) => {
        if (banner_position == 1) {
          this.banner = res.data;
        } else if (banner_position == 3) {
          this.ad = res.data;
        }
      });
    },
  },
  components: {
    "goods-cell": GoodsCell,
  },
};
</script>

<style lang="scss">
.home-index {
  .carousel {
    position: relative;

    .el-carousel {
      width: 100%;
      overflow: hidden;

      .el-carousel__container {
        height: 460px !important;

        .el-carousel__item {
          height: 100% !important;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .login {
      width: 1200px;
      height: 460px;
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      bottom: 0;
      margin: auto;

      .content {
        position: relative;
        z-index: 2;
        width: 200px;
        min-height: calc(100% - 100px);
        margin: 50px 0;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.45);
        opacity: 1;

        .top {
          width: 100%;
          margin-bottom: 10px;

          .content-item {
            width: 336px;
            height: 200px;
            opacity: 1;
            border-radius: 8px;

            .img {
              width: 75px;
              height: 75px;
            }

            &:nth-of-type(1) {
              background: rgba(255, 47, 47, 1);
            }

            &:nth-of-type(2) {
              background: #37d343;
            }

            &:nth-of-type(3) {
              background: #0f7efb;
            }
          }
        }

        .bottom {
          width: 100%;
          height: calc(100% - 170px);

          .ad {
            width: 122px;
            height: 92px;
          }

          .vip {
            width: 166px;
            height: 44px;
            background: rgba(69, 142, 246, 1);
            box-shadow: 0px 2px 4px rgba(10, 85, 192, 1);
            opacity: 1;
            border-radius: 46px;
          }

          .supplier {
            width: 166px;
            height: 44px;
            background: rgba(254, 239, 50, 1);
            box-shadow: 0px 2px 8px rgba(109, 102, 8, 0.55);
            border-radius: 46px;
          }
        }
      }
    }
  }

  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;
    padding-bottom: 0;

    .show-content {
      width: 100%;
      margin-bottom: 30px;

      .content-item {
        width: 336px;
        height: 200px;
        opacity: 1;
        border-radius: 8px;

        .img {
          width: 75px;
          height: 75px;
        }

        &:nth-of-type(1) {
          background: rgba(255, 47, 47, 1);
        }

        &:nth-of-type(2) {
          background: #37d343;
        }

        &:nth-of-type(3) {
          background: #0f7efb;
        }
      }
    }

    .goods-box {
      width: 100%;
      margin-bottom: 20px;
      display: flex;

      .brick-img-item {
        width: 280px;
        flex-shrink: 0;

        .left {
          width: 100%;
          height: 100%;
        }
      }

      .right {
        margin-left: 20px;
        flex-grow: 1;
      }
    }
  }

  .el-backtop {
    width: 40px;
    height: 85px;
    background-color: transparent;
    border-radius: 0;
    border: none;
    box-shadow: none;

    .back-top {
      width: 40px;
      height: 40px;
      background-color: #458ef6;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/homePage/homeIndex/index.vue